export const VERSION = '10.0.0';